import { render, staticRenderFns } from "./PublicProfiles.vue?vue&type=template&id=18a65530&scoped=true"
import script from "./PublicProfiles.vue?vue&type=script&lang=js"
export * from "./PublicProfiles.vue?vue&type=script&lang=js"
import style0 from "./PublicProfiles.vue?vue&type=style&index=0&id=18a65530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a65530",
  null
  
)

export default component.exports